import React from 'react';
import PropTypes from 'prop-types';

import * as PL from 'react-patterns';

const BodyText = PL.typography.textblock.BodyText;
const Ingress = PL.typography.textblock.Ingress;
const Disclaimer = PL.typography.textblock.Disclaimer;
const H1 = PL.typography.header.H1;
const H4 = PL.typography.header.H4;

const RexBlurb = (props) => (
  <div>
    <H1>Hyödynnä hyvän asiakkaan etusi</H1>
    <Ingress>Haluamme kiittää asiakkuudestasi ja tarjoamme yhden alla olevista huippueduista. Samalla teet Elisa Viihde -palveluusi uuden 24 kk sopimuksen *).</Ingress>
    <H4>Miksi jatkaa?</H4>
    <ul className="ea-checked-list ea-pad--pad-top-2 ea-pad--pad-bottom-3" style={{ marginLeft: 0 }}>
      <li style={{ listStyleType: 'none'}}>Saat tilaajalahjan.</li>
      <li style={{ listStyleType: 'none'}}>Varmistat, että palvelusi hinta säilyy 24 kk ennallaan.</li>
    </ul>
    <H4>Elisa Viihteen käyttö säilyy ennallaan</H4>
    <BodyText>Elisa Viihde -tunnuksesi, PIN-koodisi sekä tallenteesi säilyvät ennallaan, joten voit jatkaa Elisa Viihteen käyttöä entiseen malliin. Laitetakuu on voimassa koko sopimuskauden ajan.</BodyText>
    <BodyText>Mikäli haluat jättää asiakasedun tällä kertaa käyttämättä, Elisa Viihde -sopimuksesi jatkuu toistaiseksi voimassa olevana.</BodyText>
    <Disclaimer className={['rx-disclaimer']}>*) Elisa Viihde -palvelusi 24 kk määräaikainen kokonaishinta on { props.totalPrice } €</Disclaimer>
    <Disclaimer>
      <a href="https://elisa.fi/asiakaspalvelu/aihe/sopimusehdot/ohje/" target="_blank">
        Katso Elisa Viihde -palvelun palvelukuvaus ja erityisehdot tästä
      </a><br/>
    </Disclaimer>
  </div>
);

RexBlurb.propTypes = {
  totalPrice: PropTypes.string
};

export default RexBlurb;



// WEBPACK FOOTER //
// ./web/js/components/rex/Blurb.js